import './styles.scss';
import type React from 'react';

import type { PersonListeProps } from '../../types/entities';

import PersonvelgerItem from './personliste-item';
import MessagesV2 from '../messages-v2';

const PersonListe: React.FC<PersonListeProps> = props => {
  return (
    <>
      <MessagesV2 resources={props.resources} messages={props.messages} errors={props.errors}>
        {props.children}
      </MessagesV2>
      <nav aria-label={props.resources.personvelgerHeader}>
        <ul className={'personliste'} id={props.id}>
          {props.users?.map(user => (
            <PersonvelgerItem
              key={user.profilGuid}
              user={user}
              resources={props.resources}
              highlight={props.highlightUser}
              onSelectUser={() => props.onSelectUser(user)}
            />
          ))}
        </ul>
      </nav>
    </>
  );
};

export default PersonListe;
